import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '~/UIKit';
import { useNavigation, useLocalStorage } from '~/Hooks';
import { LanguageSelector } from '~/Components/';
import { Route } from '~/Constants/Routes.constants';
import IMAGES from '~/Constants/Images.constants';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles((theme) => ({
  onboardingHeader: {
    display: 'flex',
    marginTop: 15,
    marginRight: 15,
    marginLeft: 15,
    marginBottom: 90,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      marginBottom: 30,
    },
  },

  onboardingHeaderText: {
    alignSelf: 'center',
    marginRight: 15,
  },

  onboardingHeaderButton: {
    marginRight: 15,
    marginLeft: 15,
    fontSize: '12px',
  },
  logo: {
    height: 25,
    width: 225,
    margin: '20px 0 0 30px',
    position: 'absolute',
    top: 0,
    left: 0,
  },
}));

interface IOnboardingHeaderProps {
  withLogo?: boolean;
}

export const OnboardingHeader = ({ withLogo }: IOnboardingHeaderProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { navigate } = useNavigation();
  const { logout } = useLocalStorage();

  const handleOnClick = () => {
    logout();
    navigate(Route.LOGIN);
  };

  return (
    <div className={classes.onboardingHeader}>
      {!isMobile && (
        <span className={classes.onboardingHeaderText} data-testid="alreadyHaveAnAccount">
          {t('onboarding.alreadyhaveanaccount')}
        </span>
      )}
      <Button onClick={handleOnClick} className={classes.onboardingHeaderButton} variant="outlined">
        {t('login.signIn')}
      </Button>

      <LanguageSelector />
      {withLogo && <img className={classes.logo} src={IMAGES.FitogramProLogo} />}
    </div>
  );
};
